var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c("w-input-autocomplete", {
        ref: "productSku",
        attrs: {
          "input-delay": 500,
          items: _vm.foundProducts,
          label: _vm.compLabel,
          disabled: _vm.disabled,
          auto: "",
          "select-on-focus": "",
          fancy: "",
          icon: "search",
          open: "",
        },
        on: {
          blur: function ($event) {
            return _vm.blur()
          },
          keyup: function ($event) {
            return _vm.keyup($event)
          },
          "icon-click": function ($event) {
            return _vm.searchProducts()
          },
          "item-click": function ($event) {
            return _vm.productSelected($event)
          },
          "realtime-value": function ($event) {
            return _vm.onRealTimeValue($event)
          },
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (p) {
              return [
                _c(
                  "div",
                  { style: { display: "flex", flexDirection: "row" } },
                  [
                    _c("div", { style: { flexShrink: 0 } }, [
                      _vm._v(_vm._s(p.item.Sku)),
                    ]),
                    _c("w-spacer"),
                    _c(
                      "div",
                      { staticClass: "stock-qty", style: { flexShrink: 0 } },
                      [_vm._v(_vm._s(_vm.getStockQtyText(p.item)))]
                    ),
                  ],
                  1
                ),
                _vm._v(" " + _vm._s(_vm.clean(p.item.Name)) + " "),
              ]
            },
          },
        ]),
        model: {
          value: _vm.text,
          callback: function ($$v) {
            _vm.text = $$v
          },
          expression: "text",
        },
      }),
      _c(
        "w-modal",
        {
          attrs: { "escape-close": "" },
          model: {
            value: _vm.searchProductModal,
            callback: function ($$v) {
              _vm.searchProductModal = $$v
            },
            expression: "searchProductModal",
          },
        },
        [
          _c(
            "w-card",
            { style: { maxWidth: "95%", top: "20px" } },
            [
              _c(
                "w-card-title",
                { staticClass: "blue" },
                [
                  _vm._v(" " + _vm._s(_vm.$ct("search-products")) + " "),
                  _c("w-spacer"),
                  _c(
                    "w-link",
                    {
                      attrs: { white: "" },
                      on: {
                        click: function ($event) {
                          return _vm.cancelSelectProduct()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "times" } })],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { style: { height: "calc(100vh - 180px)" } },
                [
                  _vm.hasPriceListModule
                    ? _c(
                        "div",
                        { staticClass: "tab-wrapper" },
                        [
                          _c("w-tabs", {
                            attrs: { tabs: _vm.tabs },
                            model: {
                              value: _vm.tab,
                              callback: function ($$v) {
                                _vm.tab = $$v
                              },
                              expression: "tab",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.tab == 0
                    ? _c("app-product-browse", {
                        attrs: {
                          single: !_vm.allowMultiple,
                          "search-string": _vm.searchString,
                          view: _vm.view,
                          "confirm-disabled": _vm.isFetchingFromBrowse,
                        },
                        on: {
                          "products-selected": function ($event) {
                            return _vm.modalProductSelected($event)
                          },
                          "search-changed": function ($event) {
                            _vm.searchString = $event
                          },
                        },
                      })
                    : _vm._e(),
                  _vm.tab == 1
                    ? _c("app-price-list-browse", {
                        attrs: { search: _vm.searchString, "for-sale": true },
                        on: {
                          "product-created": function ($event) {
                            return _vm.modalProductSelected($event)
                          },
                          "search-changed": function ($event) {
                            _vm.searchString = $event
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }